<template>
  <svg :class="customClass" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.75 19.5652C7.573 19.3999 6.482 19.0444 5.477 18.4989C4.47183 17.9534 3.60033 17.262 2.8625 16.4247C2.12467 15.5875 1.5465 14.634 1.128 13.5642C0.709333 12.4944 0.5 11.3575 0.5 10.1537C0.5 8.67552 0.807417 7.30594 1.42225 6.04494C2.03692 4.78411 2.91733 3.69219 4.0635 2.76919H1.375V1.26919H6.75V6.64419H5.25V3.74594C4.20517 4.51777 3.40225 5.45885 2.84125 6.56919C2.28042 7.67935 2 8.87419 2 10.1537C2 12.1332 2.634 13.8624 3.902 15.3412C5.16983 16.82 6.78583 17.7197 8.75 18.0402V19.5652ZM8.575 14.4074L4.69625 10.5132L5.75 9.45944L8.575 12.2844L14.25 6.60944L15.3038 7.67869L8.575 14.4074ZM13.25 19.0479V13.6729H14.75V16.5709C15.7885 15.7826 16.5898 14.8359 17.1538 13.7307C17.7179 12.6255 18 11.4332 18 10.1537C18 8.17419 17.366 6.44502 16.098 4.96619C14.8302 3.48735 13.2142 2.58769 11.25 2.26719V0.742188C13.6103 1.06269 15.5754 2.10535 17.1453 3.87019C18.7151 5.63485 19.5 7.72935 19.5 10.1537C19.5 11.6319 19.1926 13.003 18.5777 14.2672C17.9631 15.5312 17.0827 16.6248 15.9365 17.5479H18.625V19.0479H13.25Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: "PublishedWithChangesIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
    fill: {
      type: String,
      default: "#42BFB3",
    },
  },
};
</script>
